@import (reference) '../../../../constants/spacing.module.less';

.settings-page-title {
  padding-top: @space-16;
  padding-bottom: @space-16;
}
